import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import { grey } from '@material-ui/core/colors'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Warning'
import DialogContent from '@material-ui/core/DialogContent'

import { useAppSelector } from '~/store'

import OrderProgress from './OrderProgress'
import { ORDER_DISPLAY_MODES } from './OrderProcessor'
import { getStockAssignmentByItemIndex } from './utils'

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        display: 'flex',
    },
    stockUnitInfo: {
        display: 'flex',
        padding: '20px 30px 30px 30px',
        alignItems: 'flex-start',
        width: '100%',
    },
    coverImage: {
        width: '25vw',
        minWidth: '25vw',
        marginRight: 50,
    },
    rightPanel: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    productName: {},
    stockUnitSection: {
        display: 'flex',
        marginTop: 40,
    },
    stockUnitSubSection: {
        marginRight: 40,
    },
    stockUnitSubSectionTitle: {
        color: grey[500],
        fontSize: '1.1rem !important',
    },
    stockUnitSubSectionText: {
        fontSize: '1.1rem !important',
        marginTop: 10,
    },
    row: {
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: 40,
    },
    unitsRequired: {},
    unitsRequiredTitle: {
        color: grey[500],
        fontSize: '1.3rem !important',
    },
    unitsRequiredText: {
        color: grey[400],
    },
    unitsStillNeeded: {
        marginRight: 40,
    },
    unitsStillNeededTitle: {
        color: grey[500],
        fontSize: '1.3rem !important',
    },
    prompt: {
        color: grey[500],
        marginTop: 20,
        fontSize: '1.2rem !important',
    },
    scanIcon: {
        fontSize: 50,
        marginRight: 10,
    },
    confirmIcon: {
        marginTop: 5,
        fontSize: 60,
    },
    scannedMessage: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 40,
    },
    scanErrorText: {
        color: theme.palette.error.main,
        fontSize: '1.3rem !important',
    },
    verticalSpacer: {
        flex: '1 1 auto',
    },
    itemControls: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    previousItemButton: {
        marginRight: '10px !important',
    },
    nextItemButton: {},
    serialNumberRequired: {
        display: 'flex',
        marginTop: 10,
        fontSize: '1.2rem !important',
        color: grey[500],
        alignItems: "center"
    },
    serialNumberRequiredText: {
        fontSize: '1.2rem !important',
        marginTop: 6,
        marginLeft: 8,
    },
    invalidSerialNumber: {
        color: theme.palette.error.main,
    },
}))

const OneByOneProcessing = ({
    fulfillment,
    fulfillmentLineItem,
    sliInfo,
    currentFulfillmentLineItemIndex,
    currentItemUnitIndex,
    handleNextItemClick,
    handleConfirmItemClick,
    handlePreviousItemClick,
    handleItemUnitSelect,
}) => {
    const classes = useStyles()
    const { staticRoot } = useAppSelector((state) => state.initial)

    if (!fulfillmentLineItem || !sliInfo) {
        return <DialogContent className={classes.dialogContent} />
    }

    const stockAssignment = getStockAssignmentByItemIndex(fulfillmentLineItem, currentItemUnitIndex)
    const assignedLot = stockAssignment?.stock?.lot
    const assignSerialNumberResult = stockAssignment?.assignSerialNumberResult
    const serialNumber =
        stockAssignment?.assignSerialNumber || stockAssignment?.physical_item?.serial_number
    const trackSerialNumber =
        fulfillmentLineItem?.stock_record?.stock_item?.stock_item_warehouse_config
            ?.track_serial_number

    const serialNumberIsInvalid = !!assignSerialNumberResult?.error_message

    console.log(
        'OneByOneProcessing',
        fulfillment,
        fulfillmentLineItem,
        currentFulfillmentLineItemIndex,
        currentItemUnitIndex,
        stockAssignment
    )

    return (
        <DialogContent className={classes.dialogContent}>
            <div className={classes.stockUnitInfo}>
                <img className={classes.coverImage} src={sliInfo.image} alt="Product" />
                <div className={classes.rightPanel}>
                    <OrderProgress
                        fulfillment={fulfillment}
                        onItemUnitSelect={handleItemUnitSelect}
                        currentFulfillmentLineItemIndex={currentFulfillmentLineItemIndex}
                        currentItemUnitIndex={currentItemUnitIndex}
                        orderDisplayMode={ORDER_DISPLAY_MODES.ALL_AT_ONCE}
                    />
                    <Typography variant="h5" className={classes.productName}>
                        {sliInfo.productName}
                    </Typography>
                    <div className={classes.stockUnitSection}>
                        <div className={classes.stockUnitSubSection}>
                            <Typography className={classes.stockUnitSubSectionTitle} variant="h5">
                                {gettext('SKU')}
                            </Typography>
                            <Typography className={classes.stockUnitSubSectionText} variant="h5">
                                {sliInfo.sku}
                            </Typography>
                        </div>
                        {sliInfo.skuName && (
                            <div className={classes.stockUnitSubSection}>
                                <Typography
                                    className={classes.stockUnitSubSectionTitle}
                                    variant="h5"
                                >
                                    {gettext('SKU name')}
                                </Typography>
                                <Typography
                                    className={classes.stockUnitSubSectionText}
                                    variant="h5"
                                >
                                    {sliInfo.skuName}
                                </Typography>
                            </div>
                        )}
                        {fulfillmentLineItem.stock_record?.stock_item?.barcode && (
                            <div className={classes.stockUnitSubSection}>
                                <Typography
                                    className={classes.stockUnitSubSectionTitle}
                                    variant="h5"
                                >
                                    {gettext('Barcode')}
                                </Typography>
                                <Typography
                                    className={classes.stockUnitSubSectionText}
                                    variant="h5"
                                >
                                    {fulfillmentLineItem.stock_record?.stock_item?.barcode}
                                </Typography>
                            </div>
                        )}
                        {assignedLot && (
                            <div className={classes.stockUnitSubSection}>
                                <Typography
                                    className={classes.stockUnitSubSectionTitle}
                                    variant="h5"
                                >
                                    {gettext('Lot ID')}
                                </Typography>
                                <Typography
                                    className={classes.stockUnitSubSectionText}
                                    variant="h5"
                                >
                                    {assignedLot.lot_id}
                                </Typography>
                            </div>
                        )}
                        {serialNumber && (
                            <div className={classes.stockUnitSubSection}>
                                <Typography
                                    className={classes.stockUnitSubSectionTitle}
                                    variant="h5"
                                >
                                    {gettext('Serial Number')}
                                </Typography>
                                <Typography
                                    className={classNames(
                                        classes.stockUnitSubSectionText,
                                        serialNumberIsInvalid && classes.invalidSerialNumber
                                    )}
                                    variant="h5"
                                >
                                    {serialNumber}
                                </Typography>
                            </div>
                        )}
                    </div>
                    <div className={classes.row}>
                        <div className={classes.unitsStillNeeded}>
                            <Typography className={classes.unitsStillNeededTitle} variant="h5">
                                {gettext('Units still needed')}
                            </Typography>
                            {fulfillmentLineItem.confirmed ? (
                                <CheckCircleIcon className={classes.confirmIcon} color="primary" />
                            ) : (
                                <Typography className={classes.unitsStillNeededText} variant="h3">
                                    {fulfillmentLineItem.quantity - fulfillmentLineItem.numPacked}
                                </Typography>
                            )}
                        </div>

                        <div className={classes.unitsRequired}>
                            <Typography className={classes.unitsRequiredTitle} variant="h5">
                                {gettext('Units required')}
                            </Typography>
                            <Typography className={classes.unitsRequiredText} variant="h3">
                                {fulfillmentLineItem.quantity}
                            </Typography>
                        </div>

                        {fulfillmentLineItem.checkBarcodeError && (
                            <div className={classes.scannedMessage}>
                                <WarningIcon className={classes.scanIcon} color="error" />
                                <Typography className={classes.scanErrorText} variant="h5">
                                    {gettext('Does not match barcode for this product')}
                                </Typography>
                            </div>
                        )}

                        {serialNumberIsInvalid && (
                            <div className={classes.scannedMessage}>
                                <WarningIcon className={classes.scanIcon} color="error" />
                                <Typography className={classes.scanErrorText} variant="h5">
                                    {assignSerialNumberResult?.error_message}
                                </Typography>
                            </div>
                        )}
                    </div>
                    {!fulfillmentLineItem.confirmed && (
                        <Typography variant="h5" className={classes.prompt}>
                            {gettext('Scan product or press Confirm Item and Continue')}
                        </Typography>
                    )}
                    {trackSerialNumber && (
                        <div className={classes.serialNumberRequired}>
                            <img
                                className={classes.scanBarcodeIcon}
                                src={staticRoot + 'web/img/barcode.svg'}
                                alt="Barcode"
                                style={{ width: 36 }}
                            />

                            <Typography variant="h5" className={classes.serialNumberRequiredText}>
                                {gettext('Serial number scan required')}
                            </Typography>
                        </div>
                    )}

                    <div className={classes.verticalSpacer} />
                    <div className={classes.itemControls}>
                        <Button
                            className={classes.previousItemButton}
                            color="secondary"
                            variant="outlined"
                            disabled={currentFulfillmentLineItemIndex === 0}
                            onClick={handlePreviousItemClick}
                            disableFocusRipple
                            disableRipple
                        >
                            {gettext('Previous item')}
                        </Button>
                        {fulfillmentLineItem.confirmed ? (
                            <Button
                                className={classes.nextItemButton}
                                color="secondary"
                                variant="contained"
                                onClick={handleNextItemClick}
                                disabled={
                                    currentFulfillmentLineItemIndex >=
                                    fulfillment.fulfillment_line_items.length - 1
                                }
                                disableFocusRipple
                                disableRipple
                            >
                                {gettext('Next item')}
                            </Button>
                        ) : (
                            <Button
                                className={classes.nextItemButton}
                                color="secondary"
                                variant="contained"
                                onClick={handleConfirmItemClick}
                                disableFocusRipple
                                disableRipple
                            >
                                {gettext('Confirm item and continue')}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </DialogContent>
    )
}

export default OneByOneProcessing
